// Report and block for Social Feed and Buddy Finder (App Review Guideline 1.2), backed by
// routers/moderation.py. Plain browser dialogs, like the delete-post confirm: the iOS and Android
// apps show them as native dialogs. Each helper handles its own errors (an alert with the
// message) and resolves to true only when the action went through, so callers just update
// their state on true.

const REASON_MAX_LENGTH = 1000; // routers/moderation.py REASON_MAX_LENGTH

const LABELS = { post: "post", comment: "comment", message: "message", profile: "profile" };

function dialogs(deps) {
  return {
    prompt: deps.prompt || ((text) => window.prompt(text, "")),
    confirm: deps.confirm || ((text) => window.confirm(text)),
    alert: deps.alert || ((text) => window.alert(text)),
  };
}

export async function reportContent(apiFetch, targetType, targetId, deps = {}) {
  const { prompt, alert } = dialogs(deps);
  const reason = prompt(
    `Report this ${LABELS[targetType]} to the FlowLine team?\n\nOptionally, tell us what's wrong with it:`
  );
  if (reason === null || reason === undefined) return false; // cancelled
  try {
    await apiFetch("/moderation/reports", {
      method: "POST",
      body: JSON.stringify({
        target_type: targetType,
        target_id: targetId,
        reason: reason.trim().slice(0, REASON_MAX_LENGTH) || null,
      }),
    });
  } catch (err) {
    alert(`Your report couldn't be sent: ${err.message}`);
    return false;
  }
  alert("Thanks. Your report was sent to the FlowLine team.");
  return true;
}

export async function blockUser(apiFetch, userId, name, deps = {}) {
  const { confirm, alert } = dialogs(deps);
  const who = name || "this user";
  const ok = confirm(
    `Block ${who}?\n\nYou won't see their posts, comments or messages any more, and you won't be ` +
      "matched with each other in Buddy Finder. They won't be told."
  );
  if (!ok) return false;
  try {
    await apiFetch(`/moderation/blocks/${userId}`, { method: "POST" });
  } catch (err) {
    alert(`Couldn't block ${who}: ${err.message}`);
    return false;
  }
  return true;
}

export async function unblockUser(apiFetch, userId, name, deps = {}) {
  const { confirm, alert } = dialogs(deps);
  const who = name || "this user";
  if (!confirm(`Unblock ${who}? You'll see their posts, comments and messages again.`)) return false;
  try {
    await apiFetch(`/moderation/blocks/${userId}`, { method: "DELETE" });
  } catch (err) {
    alert(`Couldn't unblock ${who}: ${err.message}`);
    return false;
  }
  return true;
}
